import { AccessLevel } from '@hellodarwin/core/lib/features/entities/pages-entities';

export const canAccessPlanSelection = (accessLevel: AccessLevel) =>
  accessLevel === 'free' || accessLevel === 'premium';
